<div class="row">
    <div class="col-12">
  
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
  
            <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->
          
            <!-- Position Column -->
            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef> <h5>User's E-mail</h5> </th>
              <td mat-cell *matCellDef="let element"> {{element.payload.doc.data().email}} </td>
            </ng-container>
          
            <!-- Name Column -->
            <ng-container matColumnDef="phn">
              <th mat-header-cell *matHeaderCellDef> <h5>Phone Number</h5> </th>
              <td mat-cell *matCellDef="let element"> {{element.payload.doc.data().phn}} </td>
            </ng-container>
            
            <ng-container matColumnDef="message">
                <th mat-header-cell *matHeaderCellDef> <h5>User's Message</h5> </th>
                <td mat-cell *matCellDef="let element"> {{element.payload.doc.data().message}} </td>
              </ng-container>
              
            <ng-container matColumnDef="blank">
                <th mat-header-cell *matHeaderCellDef> <h5>&nbsp;&nbsp;&nbsp;&nbsp;</h5> </th>
                <td mat-cell *matCellDef="let element">&nbsp;&nbsp;&nbsp;&nbsp;</td>
              </ng-container>
          
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        
        <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>
  
        
  </div>